import moment from 'moment';
import { weekIndices } from '../utils';

export const getDaysSinceLastVisit = (
  rxStartDate: Nullable<string>,
  lastClinicVisit: Nullable<string>,
): Nullable<number> => {
  let daysSinceLastVisitOrRxStartDate = null;
  if (lastClinicVisit) {
    daysSinceLastVisitOrRxStartDate = moment().diff(
      moment(lastClinicVisit),
      'days',
    );
  } else if (rxStartDate) {
    daysSinceLastVisitOrRxStartDate = moment().diff(
      moment(rxStartDate),
      'days',
    );
  }
  return daysSinceLastVisitOrRxStartDate;
};

export const getLessonsPerWeek = (
  patient: IFormattedPatientAdherenceDetails,
): number[] => {
  const rs = weekIndices().map((weekIndex: number) => {
    // @ts-ignore
    return patient[`week${weekIndex + 1}`];
  });
  return rs;
};
